import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";
import { toastDispatch } from "@/assets/composables/toast-dispatch";

export default {
	namespaced: true,
	state: {
		user: [],
		paymentkeys: [],
		settings: [],
		banks: [],
		bank_list: [],
		resolved_bank: null,
		preferred_bank: [],
		analytics: [],
	},
	mutations: {
		SET_DATA(state, data) {
			state.user = data;
		},
		SET_PAYMENTKEYS(state, data) {
			state.paymentkeys = data;
		},
		SET_SETTINGS(state, data) {
			state.settings = data;
			localStorage.setItem("currency", state.settings.currency);
		},
		SET_BANKS(state, data) {
			state.banks = data;
		},
		SET_BANK_LIST(state, data) {
			state.bank_list = data;
		},
		SET_RESOLVED_BANK(state, data) {
			state.resolved_bank = data;
		},
		SET_ANALYTICS(state, data) {
			state.analytics = data;
		},
		SET_PREFERRED_BANK(state, data) {
			state.preferred_bank = data;
		},
		REMOVE_BANK(state, id) {
			let bankIndex = state.banks.findIndex((bank) => bank.id === id);
			state.banks.splice(bankIndex, 1);
		},
	},
	actions: {
		async updatePassword({}, payload) {
			let result = await API.put(ROUTES().updatepassword, payload, apiConfig())
				.then((res) => {
					toast.success(`${res.data.message}`);
					router.push("/");
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async updateProfile({}, payload) {
			let result = await API.post(ROUTES().updateprofile, payload, apiConfig(true))
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async updatePayment({}, payload) {
			let result = await API.put(ROUTES().payment, payload, apiConfig())
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async updateInvoiceGenaralSettings({}, payload) {
			let result = await API.post(
				ROUTES().invoicegeneralsettings,
				payload,
				apiConfig(true)
			)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async updatePreferenceSettings({ dispatch }, payload) {
			let result = await API.put(ROUTES().preference, payload, apiConfig())
				.then((res) => {
					toast.success(`${res.data.message}`);
					dispatch("getSettings");
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async updateTaxSettings({}, payload) {
			let result = await API.put(ROUTES().taxsettings, payload, apiConfig())
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async updateNotificationSettings({}, payload) {
			let result = await API.put(
				ROUTES().notificationsettings,
				payload,
				apiConfig()
			)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});

			return result;
		},
		async getPaymentkeys({ commit }) {
			let result = await API.get(ROUTES().payment, apiConfig())
				.then((res) => {
					commit("SET_PAYMENTKEYS", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},
		async getSettings({ commit }) {
			let result = await API.get(ROUTES().settings, apiConfig())
				.then((res) => {
					commit("SET_SETTINGS", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},
		async getUser({ commit }) {
			API.get(ROUTES().authuser, apiConfig())
				.then((res) => {
					commit("SET_DATA", res.data.data);
					localStorage.setItem("user", JSON.stringify(res.data.data));
				})
				.catch((err) => {
					console.log(err);
				});
		},

		// Bank settings
		async addBankAccount({ dispatch }, payload) {
			let result = await API.post(ROUTES().bankaccount, payload, apiConfig())
				.then((res) => {
					toastDispatch(res, "success");
					dispatch("getBankAccounts");
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});

			return result;
		},

		async getBankAccounts({ commit }) {
			let result = await API.get(ROUTES().bankaccount, apiConfig())
				.then((res) => {
					commit("SET_BANKS", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},
		async updateBankAccount({}, { payload, id }) {
			let result = await API.put(
				`${ROUTES().bankaccount}/${id}`,
				payload,
				apiConfig()
			)
				.then((res) => {
					toastDispatch(res, "success");
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});

			return result;
		},

		async setPreferredBank({ dispatch }, id) {
			let result = API.put(
				`${ROUTES().bankaccount}/${id}/set-preferred`,
				{},
				apiConfig()
			)
				.then((res) => {
					toastDispatch(res, "success");
					dispatch("getBankAccounts");
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});
			return result;
		},

		async removePreferredBank({ dispatch }, id) {
			let result = API.put(
				`${ROUTES().bankaccount}/remove-preferred`,
				{},
				apiConfig()
			)
				.then((res) => {
					toastDispatch(res, "success");
					dispatch("getBankAccounts");
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});
			return result;
		},

		async getBankList({ commit }) {
			let result = API.get(`${ROUTES().banklist}`, apiConfig())
				.then((res) => {
					commit("SET_BANK_LIST", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});
			return result;
		},

		async resolveBank({ commit }, { acc_no, bank_code }) {
			let result = API.get(
				`${
					ROUTES().resolvebankaccount
				}/resolve?account_number=${acc_no}&bank_code=${bank_code}`,
				apiConfig()
			)
				.then((res) => {
					toastDispatch(res, "success");
					commit("SET_RESOLVED_BANK", res.data.data);
				})
				.catch((err) => {
					commit("SET_RESOLVED_BANK", null);
					toastDispatch(err, "error");
				});
			return result;
		},

		async getPreferredBank({ commit }) {
			let result = API.get(`${ROUTES().bankaccount}/get-preferred`, apiConfig())
				.then((res) => {
					commit("SET_PREFERRED_BANK", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});
			return result;
		},

		async deleteBank({ commit }, id) {
			let result = API.delete(`${ROUTES().bankaccount}/${id}`, apiConfig())
				.then((res) => {
					commit("REMOVE_BANK", id);
					toastDispatch(res, "success");
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});
			return result;
		},

		// Analytics
		async getAnalytics({ commit }) {
			let result = await API.get(ROUTES().analytics, apiConfig())
				.then((res) => {
					commit("SET_ANALYTICS", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},
	},
	getters: {
		user(state) {
			return state.user;
		},
		paymentkeys(state) {
			return state.paymentkeys;
		},
		settings(state) {
			return state.settings;
		},
		banks(state) {
			return state.banks;
		},
		bank_list(state) {
			return state.bank_list;
		},
		resolved_bank(state) {
			return state.resolved_bank;
		},
		preferred_bank(state) {
			return state.preferred_bank;
		},
		analytics(state) {
			return state.analytics;
		},
	},
};
